import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from "react-redux";
import configureStore from "./store/Configure";
import Header from "./components/Header";

const store = configureStore();


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Header />
        <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
